/*
  The sidebar's contents while someone is inside a library.

  Dark surfaces throughout: this renders INSIDE the shell's existing dark
  column, in place of the nav. It is not a panel on the page.
*/
.rail {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-4);
  min-height: 0;
}

.back {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-size: var(--text-sm);
  color: var(--sidebar-text);
  text-align: left;
  cursor: pointer;
}

.back:hover {
  color: #fff;
}

.timerBox {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  padding: var(--space-3);
  background: rgb(255 255 255 / 7%);
  border: 1px solid transparent;
  border-radius: var(--radius);
}

/* On duty: the mentor's timer counts supervision, not study. */
.duty {
  background: rgb(79 63 240 / 24%);
  border-color: var(--indigo);
}

.label {
  font-size: var(--text-xs);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgb(255 255 255 / 78%);
}

.value {
  font-size: var(--text-xl);
  font-weight: 600;
  color: #fff;
  /* Tabular figures so the number does not jitter as it ticks. */
  font-variant-numeric: tabular-nums;
}

.note {
  font-size: var(--text-xs);
  color: rgb(255 255 255 / 70%);
  line-height: var(--leading-tight);
}

.action {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-3);
  background: rgb(255 255 255 / 7%);
  border: 1px solid transparent;
  border-radius: var(--radius);
  font: inherit;
  font-size: var(--text-sm);
  color: var(--sidebar-text);
  text-align: left;
}

.action:disabled {
  cursor: not-allowed;
}

.action:not(:disabled) {
  cursor: pointer;
  color: #fff;
}

.action:not(:disabled):hover {
  background: rgb(255 255 255 / 14%);
}

.icon {
  font-size: var(--text-md);
}

/* Says "not yet", not "broken". */
.soon {
  margin-left: auto;
  font-size: var(--text-xs);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.65;
}

/*
  On a break: amber, because it is a state the student is IN rather than an
  action waiting to be taken. The colour is set after the white-text rule
  above and at matching specificity, or the text is white on light amber —
  which shipped invisible once.
*/
.onBreak,
.onBreak:not(:disabled) {
  background: var(--amber-soft);
  border-color: var(--amber);
  color: var(--navy);
}

:root[data-theme='dark'] .onBreak,
:root[data-theme='dark'] .onBreak:not(:disabled) {
  color: var(--amber);
}

@media (prefers-color-scheme: dark) {
  :root:not([data-theme='light']) .onBreak,
  :root:not([data-theme='light']) .onBreak:not(:disabled) {
    color: var(--amber);
  }
}

.onBreak:not(:disabled):hover {
  background: var(--amber-soft);
}

.breakText {
  display: flex;
  flex-direction: column;
  gap: 0.0625rem;
  line-height: var(--leading-tight);
}

.breakLabel {
  font-weight: 600;
}

.breakClock {
  font-size: var(--text-xs);
  font-variant-numeric: tabular-nums;
  opacity: 0.9;
}

/* Pushes Leave to the bottom of the column, always reachable. */
.spacer {
  flex: 1;
  min-height: var(--space-4);
}

.leave {
  padding: var(--space-3);
  background: none;
  border: 1px solid var(--danger);
  border-radius: var(--radius);
  font: inherit;
  font-weight: 600;
  color: var(--danger);
  cursor: pointer;
}

.leave:hover:not(:disabled) {
  background: rgb(220 38 38 / 12%);
}

@media (max-width: 40rem) {
  /* The sidebar becomes a drawer on a phone; the rail fills it. */
  .rail {
    padding: var(--space-3);
  }
}
